import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';

import logo from 'app/resources/altibox-logo-header.svg';
import { Image } from 'app/components/common/image';
import { i18n } from 'app/i18n';
import { Link } from 'app/components/common/links';
import { config } from 'app/config/config';
import { logoutActionCreator } from 'app/page/auth/redux/auth-action-creators';
import { selectIsAuthenticated } from 'app/page/auth/redux/auth-selectors';

import styles from './header.module.scss';

const Header: React.FC = () => {
    const showLogoutButton = useSelector(selectIsAuthenticated);
    const dispatch = useDispatch();

    return (
        <header className={styles.header}>
            <Link href={config.MY_PAGES_URL}>
                <Image src={logo} alt={i18n.components.header.logo.altText} className={styles.image} />
            </Link>
            {showLogoutButton && (
                <Button onClick={() => dispatch(logoutActionCreator())} className={styles.button}>
                    {i18n.components.header.button.logout}
                </Button>
            )}
        </header>
    );
};

export { Header };
